import { ref } from 'vue';

const STORAGE_KEY = 'flight-track-control-size';

export type ControlSizePreference = 'normal' | 'gloves';

const controlSizePreference = ref<ControlSizePreference>('normal');

function getStoredControlSize(): ControlSizePreference {
  if (typeof localStorage === 'undefined') return 'normal';
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'gloves' || stored === 'normal') return stored;
  return 'normal';
}

function applyToDocument(pref: ControlSizePreference): void {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.toggle('app-controls-gloves', pref === 'gloves');
}

/**
 * Initialize control size from storage. Call once before app mount (e.g. in main.ts).
 */
export function initControlSize(): void {
  const pref = getStoredControlSize();
  controlSizePreference.value = pref;
  applyToDocument(pref);
}

export function useControlSize() {
  const controlSize = controlSizePreference;

  function setControlSize(pref: ControlSizePreference): void {
    controlSizePreference.value = pref;
    if (typeof localStorage !== 'undefined') localStorage.setItem(STORAGE_KEY, pref);
    applyToDocument(pref);
  }

  return { controlSize, setControlSize };
}
